import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, BehaviorSubject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserActivityService {
  private lastActivitySubject = new BehaviorSubject<number>(Date.now());
  lastActivity$ = this.lastActivitySubject.asObservable();

  constructor(private zone: NgZone) {
    this.startTracking();
  }

  private startTracking() {
    this.zone.runOutsideAngular(() => {
      const activityEvents$ = merge(
        fromEvent(document, 'click'),
        fromEvent(document, 'mousemove'),
        fromEvent(document, 'keydown'),
        fromEvent(document, 'scroll'),
        fromEvent(document, 'touchstart')
      );

      activityEvents$
        .pipe(throttleTime(1000, undefined, { leading: true, trailing: true }))
        .subscribe(() => {
          this.lastActivitySubject.next(Date.now());
        });
    });
  }

  getLastActivityTime(): number {
    return this.lastActivitySubject.value;
  }
}
